import { render, staticRenderFns } from "./AIpageV2.vue?vue&type=template&id=07d6fcb9&scoped=true"
import script from "./AIpageV2.vue?vue&type=script&lang=js"
export * from "./AIpageV2.vue?vue&type=script&lang=js"
import style0 from "./AIpageV2.vue?vue&type=style&index=0&id=07d6fcb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d6fcb9",
  null
  
)

export default component.exports